"use strict";

import angular from "angular";

import template from "./parameterization-accounts-plan.component.html";
import "./parameterization-accounts-plan.component.scss";
import helpParameterizationDialogTemplate from "../../dialogs/help-parameterization/help-parameterization-dialog.html";
import removeParameterizationDialogTemplate from "../../dialogs/remove-parameterization/remove-parameterization-dialog.html";

import { CompanyEntity } from "../../../entity/CompanyEntity";
import { Available } from "../../../gateway/Available/Available";
import { Company } from "../../../gateway/Company/Company";
import { Point } from "../../../gateway/Point/Point";
import { PointCalculated } from "../../../gateway/PointCalculated/PointCalculated";
import { Serie } from "../../../gateway/Serie/Serie";
import { UserDataAdapter } from "../../../presentation/adpters/UserDataAdapter";
import { DepartmentCopiesSyncService } from "../../../presentation/services/DepartmentCopiesSyncService/DepartmentCopiesSyncService";
import { PopulateManager } from "../../../presentation/services/PopulateManager/PopulateManager";
import { PublicCompany } from "../../../presentation/services/PublicCompany/PublicCompany";
import { SeriesService } from "../../../presentation/services/Series/SeriesService";
import { NormalizeString } from "../../../utils/normalize-string/NormalizeString";

class ParameterizationAccountsPlanComponent {
    PopulateManager = new PopulateManager();
    Serie = new Serie({ PopulateManager: this.PopulateManager });
    SeriesService = new SeriesService(this.Serie);
    Point = new Point({ PopulateManager: this.PopulateManager });
    Available = new Available();
    Company = new Company();
    PointCalculated = new PointCalculated();
    user = new UserDataAdapter().user();

    accountsPlanNucont = [];
    accountsPlanNucontFiltered = [];
    accountsPlanCompany = [];
    accountsPlanCompanyFiltered = [];
    openedSeriesCompany = {};
    showSeriesParamterized = true;
    seriesNucontWithAssociated = {};
    allExpanded = false;
    currentFilter = "filtered";
    companySeriesPlanDisabled = {};
    seriesParentsMap = {};
    hasChangeSeries = false;
    searchSerieNucont = "";
    searchSerieCompany = "";
    visualizationsList = [];
    visualizationsListBefore = [];

    constructor(
        DesnuDialogService,
        $scope,
        $mdDialog,
        $timeout,
        $element,
        LoaderService,
        ChatHubsbotService
    ) {
        this.DesnuDialogService = DesnuDialogService;
        this.$scope = $scope;
        this.$mdDialog = $mdDialog;
        this.$timeout = $timeout;
        this.$element = $element;
        this.LoaderService = LoaderService;
        this.ChatHubsbotService = ChatHubsbotService;
    }

    $onInit() {
        this.ChatHubsbotService.hide();
        this.company = new CompanyEntity(this.companyData);
        this.hasPermissionCompanyModel = PublicCompany.hasPermissionModelToModify(
            this.company.props._id,
            this.user
        );
        this.setAccountsPlanNucont();
        this.setAccountsPlanCompany();
        this.setSeriesParentsMap();
        this.setCompanySeriesPlanDisabled();
        this.filterAccountsPlanNucont();
        this.filterAccountsPlanCompany();
        this.setVisualizationsList();
        this.scrollToActiveSerieNucont();
        this.focusSerieParameterized();
    }

    focusSerieParameterized() {
        if (!this.serieNucontSelected?._id) return;
        const serieParameterized = this.seriesNucontWithAssociated[
            this.serieNucontSelected._id
        ]?.associatedSeries?.[0]?._id;
        const fathersIds =
            this.seriesParentsMap[serieParameterized]?.fathers || [];
        if (fathersIds?.length) {
            fathersIds.forEach((fatherId) => {
                const fatherSerie = this.accountsPlanCompany.find(
                    (serie) => serie._id === fatherId
                );
                if (fatherSerie) {
                    this.onExpandSerie(fatherSerie);
                }
            });
        }
        setTimeout(() => {
            const element = angular.element(
                document.querySelector(
                    `[data-serie-id="${serieParameterized}"]`
                )
            );
            if (element.length) {
                element[0].scrollIntoView({
                    behavior: "smooth",
                    block: "center"
                });
            }
        }, 500);
    }

    $onDestroy() {
        this.ChatHubsbotService.show();
    }

    setAccountsPlanNucont() {
        const accountsPlanNucont = this.Serie.get(
            {
                sources: "accounting",
                companyId: "EMPRESA_NUCONT",
                "metadata.isPublicAccountsPlan": true,
                $or: [
                    { "metadata.scenarioKpi": { $exists: false } },
                    { "metadata.scenarioKpi": false }
                ]
            },
            {
                hierarchize: true,
                $associated: true,
                sort: { classifier: 1 }
            },
            this.company.props._id
        );
        this.accountsPlanNucont = this.getSeriesToParameterize(
            accountsPlanNucont,
            this.seriesIdsToParameterize
        );
        this.setSeriesNucontWithAssociated();
    }

    getSeriesToParameterize(accountsPlanNucont, seriesIdsToParameterize) {
        if (!seriesIdsToParameterize?.length) return accountsPlanNucont;
        return accountsPlanNucont.filter((serie) => {
            return seriesIdsToParameterize.includes(serie._id);
        });
    }

    setSeriesNucontWithAssociated() {
        for (const serie of this.accountsPlanNucont) {
            this.seriesNucontWithAssociated[serie._id] = {
                associatedSeries: serie.associatedSeries,
                hasChanges: false
            };
        }
    }

    setAccountsPlanCompany() {
        this.accountsPlanCompany = this.Serie.getByClassifierBase({
            companyId: this.company.props._id,
            classifierBase: this.serieNucontSelected.classifier
        });
        this.accountsPlanCompany.forEach((serie) => {
            if (serie.classifier?.length == 1) {
                this.openedSeriesCompany[serie._id] = true;
            } else {
                this.openedSeriesCompany[serie._id] = false;
            }
        });
    }

    setSeriesParentsMap() {
        // Inicializa o mapa vazio
        this.seriesParentsMap = {};
        if (!this.accountsPlanCompany || !this.accountsPlanCompany.length) {
            return;
        }
        // Primeiro, inicializa todos os IDs no mapa com relacionamentos diretos
        this.accountsPlanCompany.forEach((serie) => {
            this.seriesParentsMap[serie._id] = {
                childrens: [],
                fathers: []
            };
        });
        // Mapeia os relacionamentos diretos (pai -> filho imediato)
        this.accountsPlanCompany.forEach((serie) => {
            if (serie.compound && serie.compound.length > 0) {
                // Adiciona filhos diretos
                this.seriesParentsMap[serie._id].childrens = [
                    ...serie.compound
                ];
                // Para cada filho direto, adiciona esta conta como pai direto
                serie.compound.forEach((childId) => {
                    if (this.seriesParentsMap[childId]) {
                        this.seriesParentsMap[childId].fathers.push(serie._id);
                    }
                });
            }
        });
        // Função recursiva para buscar todos os descendentes
        const getAllDescendants = (serieId, visited = new Set()) => {
            if (visited.has(serieId)) {
                return [];
            }
            visited.add(serieId);

            const directChildren =
                this.seriesParentsMap[serieId]?.childrens || [];
            let allDescendants = [...directChildren];

            directChildren.forEach((childId) => {
                const childDescendants = getAllDescendants(childId, visited);
                allDescendants = allDescendants.concat(childDescendants);
            });

            return [...new Set(allDescendants)]; // Remove duplicatas
        };
        // Função recursiva para buscar todos os ancestrais
        const getAllAncestors = (serieId, visited = new Set()) => {
            if (visited.has(serieId)) {
                return [];
            }
            visited.add(serieId);

            const directParents = this.seriesParentsMap[serieId]?.fathers || [];
            let allAncestors = [...directParents];

            directParents.forEach((parentId) => {
                const parentAncestors = getAllAncestors(parentId, visited);
                allAncestors = allAncestors.concat(parentAncestors);
            });

            return [...new Set(allAncestors)]; // Remove duplicatas
        };
        // Agora atualiza o mapa com todos os relacionamentos recursivos
        this.accountsPlanCompany.forEach((serie) => {
            // Busca todos os descendentes recursivamente
            this.seriesParentsMap[serie._id].childrens = getAllDescendants(
                serie._id
            );
            // Busca todos os ancestrais recursivamente
            this.seriesParentsMap[serie._id].fathers = getAllAncestors(
                serie._id
            );
        });
    }

    setCompanySeriesPlanDisabled() {
        // Inicializa o mapa com todas as contas como habilitadas (false)
        this.companySeriesPlanDisabled = {};
        if (
            !this.accountsPlanCompany ||
            !this.accountsPlanCompany.length ||
            !this.serieNucontSelected?._id
        ) {
            return;
        }
        // Primeiro, inicializa todas as contas como habilitadas
        this.accountsPlanCompany.forEach((serie) => {
            this.companySeriesPlanDisabled[serie._id] = false;
        });
        const serieSelected = this.serieNucontSelected;
        if (!serieSelected) return;
        const seriesParameterized =
            this.seriesNucontWithAssociated[serieSelected._id]
                .associatedSeries || [];
        // Para cada conta parametrizada, desabilita ela e seus relacionamentos
        seriesParameterized.forEach((parameterizedSerie) => {
            const serieId = parameterizedSerie._id;
            // Desabilita todos os filhos (descendentes) da conta parametrizada
            const childrens = this.seriesParentsMap[serieId]?.childrens || [];
            childrens.forEach((childId) => {
                this.companySeriesPlanDisabled[childId] = true;
            });
            // Desabilita todos os pais (ancestrais) da conta parametrizada
            const fathers = this.seriesParentsMap[serieId]?.fathers || [];

            fathers.forEach((fatherId) => {
                this.companySeriesPlanDisabled[fatherId] = true;
            });
        });
    }

    onSelectSerieNucont(serie) {
        if (serie.metadata?.notAssociated) return;
        if (serie._id == this.serieNucontSelected?._id) {
            this.serieNucontSelected = {};
        } else {
            this.serieNucontSelected = serie;
        }
        this.setAccountsPlanCompanyByFilter({ preserveOpened: true });
        this.focusSerieParameterized();
    }

    onToggleSeriesParamterized() {
        this.showSeriesParamterized = !this.showSeriesParamterized;
    }

    onExpandAllSeriesCompany() {
        this.allExpanded = true;
        this.accountsPlanCompany.forEach((serie) => {
            this.openedSeriesCompany[serie._id] = true;
        });
    }

    onCollapseAllSeriesCompany() {
        this.allExpanded = false;
        this.accountsPlanCompany.forEach((serie) => {
            if (serie.classifier?.length == 1) {
                this.openedSeriesCompany[serie._id] = true;
            } else {
                this.openedSeriesCompany[serie._id] = false;
            }
        });
    }

    onHideSerie(serie) {
        if (!serie.compound.length) return;
        const allCompounds = this.seriesParentsMap[serie._id].childrens;
        allCompounds.forEach((compound) => {
            this.openedSeriesCompany[compound] = false;
        });
    }

    onExpandSerie(serie) {
        if (!serie.compound.length) return;
        serie.compound.forEach((compound) => {
            this.openedSeriesCompany[compound] = true;
        });
    }

    isParameterized(serie) {
        if (!this.serieNucontSelected?._id) return false;
        const index = this.seriesNucontWithAssociated[
            this.serieNucontSelected._id
        ]?.associatedSeries?.findIndex((s) => s._id == serie._id);
        if (index > -1) return true;
        else return false;
    }

    isSerieDisabledToParameterize(serie) {
        if (!this.serieNucontSelected?._id) return true;
        if (this.loading) return true;
        if (!this.serieNucontSelected?._id) return true;
        if (!this.hasPermissionCompanyModel) {
            return true;
        }
        // if (this.companySeriesPlanDisabled[serie._id]) {
        //     return true;
        // }
        return false;
    }

    onRemoveSerieParameterizedChip(serie) {
        this.hasChangeSeries = true;
        const index = this.seriesNucontWithAssociated[
            this.serieNucontSelected._id
        ].associatedSeries.findIndex((s) => s._id == serie._id);
        if (index > -1)
            this.seriesNucontWithAssociated[
                this.serieNucontSelected._id
            ].associatedSeries.splice(index, 1);
        this.seriesNucontWithAssociated[
            this.serieNucontSelected._id
        ].hasChanges = true;
        this.setCompanySeriesPlanDisabled();
    }

    onParameterizeSerie(serie) {
        this.hasChangeSeries = true;
        const index = this.seriesNucontWithAssociated[
            this.serieNucontSelected._id
        ].associatedSeries.findIndex((s) => s._id == serie._id);
        if (index > -1) {
            this.seriesNucontWithAssociated[
                this.serieNucontSelected._id
            ].associatedSeries.splice(index, 1);
        } else {
            this.seriesNucontWithAssociated[
                this.serieNucontSelected._id
            ].associatedSeries.push(serie);
        }
        this.seriesNucontWithAssociated[
            this.serieNucontSelected._id
        ].hasChanges = true;
        this.setCompanySeriesPlanDisabled();
    }

    onToggleSyntheticSerie(serie) {
        this.hasChangeSeries = true;
        const index = this.seriesNucontWithAssociated[
            this.serieNucontSelected._id
        ].associatedSeries.findIndex((i) => i._id == serie._id);
        if (index > -1)
            this.seriesNucontWithAssociated[
                this.serieNucontSelected._id
            ].associatedSeries.splice(index, 1);
        else
            this.seriesNucontWithAssociated[
                this.serieNucontSelected._id
            ].associatedSeries.push(serie);
        const fathersIds = this.seriesParentsMap[serie._id].fathers;
        fathersIds.forEach((fatherId) => {
            const index = this.seriesNucontWithAssociated[
                this.serieNucontSelected._id
            ].associatedSeries.findIndex((i) => i._id == fatherId);
            if (index > -1)
                this.seriesNucontWithAssociated[
                    this.serieNucontSelected._id
                ].associatedSeries.splice(index, 1);
        });
        const childrensIds = this.seriesParentsMap[serie._id].childrens;
        childrensIds.forEach((childrenId) => {
            const index = this.seriesNucontWithAssociated[
                this.serieNucontSelected._id
            ].associatedSeries.findIndex((i) => i._id == childrenId);
            if (index > -1)
                this.seriesNucontWithAssociated[
                    this.serieNucontSelected._id
                ].associatedSeries.splice(index, 1);
        });
        this.seriesNucontWithAssociated[
            this.serieNucontSelected._id
        ].hasChanges = true;
        this.setCompanySeriesPlanDisabled();
    }

    onToggleAllCompounds(serie) {
        this.hasChangeSeries = true;
        if (!serie.compound.length) return;
        const indexMainSerie = this.seriesNucontWithAssociated[
            this.serieNucontSelected._id
        ].associatedSeries.findIndex((i) => i._id == serie._id);
        if (indexMainSerie > -1)
            this.seriesNucontWithAssociated[
                this.serieNucontSelected._id
            ].associatedSeries.splice(indexMainSerie, 1);
        const fathersIds = this.seriesParentsMap[serie._id].fathers;
        fathersIds.forEach((fatherId) => {
            const index = this.seriesNucontWithAssociated[
                this.serieNucontSelected._id
            ].associatedSeries.findIndex((i) => i._id == fatherId);
            if (index > -1)
                this.seriesNucontWithAssociated[
                    this.serieNucontSelected._id
                ].associatedSeries.splice(index, 1);
        });
        const childrensIds = this.seriesParentsMap[serie._id].childrens.filter(
            (childrenId) => !serie.compound.includes(childrenId)
        );
        childrensIds.forEach((childrenId) => {
            const index = this.seriesNucontWithAssociated[
                this.serieNucontSelected._id
            ].associatedSeries.findIndex((i) => i._id == childrenId);
            if (index > -1)
                this.seriesNucontWithAssociated[
                    this.serieNucontSelected._id
                ].associatedSeries.splice(index, 1);
        });
        const isAllCompoundsSelected = this.isAllCompoundsSelected(serie);
        const seriesCompound = this.accountsPlanCompany.filter((s) =>
            serie.compound.includes(s._id)
        );
        seriesCompound.forEach((s) => {
            const index = this.seriesNucontWithAssociated[
                this.serieNucontSelected._id
            ].associatedSeries.findIndex((i) => i._id == s._id);
            if (isAllCompoundsSelected) {
                if (index > -1)
                    this.seriesNucontWithAssociated[
                        this.serieNucontSelected._id
                    ].associatedSeries.splice(index, 1);
            } else {
                if (index == -1)
                    this.seriesNucontWithAssociated[
                        this.serieNucontSelected._id
                    ].associatedSeries.push(s);
            }
        });
        this.seriesNucontWithAssociated[
            this.serieNucontSelected._id
        ].hasChanges = true;
        this.setCompanySeriesPlanDisabled();
    }

    isAllCompoundsSelected(serie) {
        if (!serie.compound.length) return false;
        const seriesCompound = this.accountsPlanCompany.filter((s) =>
            serie.compound.includes(s._id)
        );
        return seriesCompound.every((s) => this.isParameterized(s));
    }

    onFilterAccountsPlanCompany(filter) {
        this.currentFilter = filter;
        this.setAccountsPlanCompanyByFilter();
    }

    setAccountsPlanCompanyByFilter({ preserveOpened } = {}) {
        const params = { companyId: this.company.props._id };
        if (this.currentFilter == "filtered" && !this.allExpanded) {
            params.classifierBase = this.serieNucontSelected.classifier;
            this.accountsPlanCompany = this.Serie.getByClassifierBase(params);
            this.accountsPlanCompany.forEach((serie) => {
                if (serie.classifier?.length == 1) {
                    this.openedSeriesCompany[serie._id] = true;
                } else {
                    // this.openedSeriesCompany[serie._id] = false;
                }
            });
        } else if (this.currentFilter == "filtered" && this.allExpanded) {
            params.classifierBase = this.serieNucontSelected.classifier;
            this.accountsPlanCompany = this.Serie.getByClassifierBase(params);
            if (!preserveOpened) {
                this.accountsPlanCompany.forEach((serie) => {
                    this.openedSeriesCompany[serie._id] = true;
                });
            }
        } else if (this.currentFilter == "complete" && !this.allExpanded) {
            this.accountsPlanCompany = this.Serie.getByClassifierBase(params);
            if (!preserveOpened) {
                this.accountsPlanCompany.forEach((serie) => {
                    if (serie.classifier?.length == 1) {
                        this.openedSeriesCompany[serie._id] = true;
                    } else {
                        this.openedSeriesCompany[serie._id] = false;
                    }
                });
            }
        } else if (this.currentFilter == "complete" && this.allExpanded) {
            this.accountsPlanCompany = this.Serie.getByClassifierBase(params);
            if (!preserveOpened) {
                this.accountsPlanCompany.forEach((serie) => {
                    this.openedSeriesCompany[serie._id] = true;
                });
            }
        }
        this.setSeriesParentsMap();
        this.setCompanySeriesPlanDisabled();
        this.filterAccountsPlanCompany();
    }

    getTooltipSerieParameterized(serie) {
        const seriesNucontWithAssociatedIds = Object.keys(
            this.seriesNucontWithAssociated
        );
        const seriesNucontAssociatedIds = seriesNucontWithAssociatedIds.filter(
            (id) => {
                return this.seriesNucontWithAssociated[
                    id
                ].associatedSeries.find((s) => s._id === serie._id);
            }
        );
        const seriesNucont = this.accountsPlanNucont.filter((s) => {
            return seriesNucontAssociatedIds.includes(s._id);
        });
        return `Conta parametrizada em "${
            seriesNucont?.length
                ? seriesNucont
                      .map((a) => `${a.classifierView} ${a.name}`)
                      .join(", ")
                : ""
        }"`;
    }

    getSerieParameterized(serie) {
        const seriesNucontWithAssociatedIds = Object.keys(
            this.seriesNucontWithAssociated
        );
        const seriesNucontAssociatedIds = seriesNucontWithAssociatedIds.filter(
            (id) => {
                return this.seriesNucontWithAssociated[
                    id
                ].associatedSeries.find((s) => s._id === serie._id);
            }
        );
        const seriesNucont = this.accountsPlanNucont.filter((s) => {
            return seriesNucontAssociatedIds.includes(s._id);
        });
        return seriesNucont?.length
            ? seriesNucont.map((a) => a.classifierView).join(", ")
            : "";
    }

    async onSave() {
        this.LoaderService.setProgress(true);
        this.loading = true;
        const seriesToSave = [];
        for (const serieId of Object.keys(this.seriesNucontWithAssociated)) {
            const serie = this.seriesNucontWithAssociated[serieId];
            if (serie.hasChanges) {
                seriesToSave.push({
                    _id: serieId,
                    associated: serie.associatedSeries.map((s) => s._id)
                });
                this.seriesNucontWithAssociated[serieId].hasChanges = false;
            }
        }
        await this.Serie.associate(
            this.company.props._id,
            seriesToSave,
            this.user._id
        );
        this.syncFromAccounting();
        this.hasChangeSeries = false;
        this.loading = false;
        this.LoaderService.setProgress(false);
        this.handleAfterSave();
        this.$scope.$applyAsync();
    }

    syncFromAccounting() {
        const departmentCopiesSyncService = new DepartmentCopiesSyncService({
            PointHttpGateway: this.Point,
            SerieHttpGateway: this.Serie,
            AvailableHttpGateway: this.Available,
            CompanyHttpGateway: this.Company,
            PopulateManager: this.PopulateManager,
            PointCalculated: this.PointCalculated
        });
        departmentCopiesSyncService.syncsFromAccounting({
            company: this.company,
            clearCollections: false
        });
    }

    onRemove() {
        this.DesnuDialogService.custom({
            controller: "RemoveParameterizationDialogCtrl as $ctrl",
            locals: {
                templateHtml: removeParameterizationDialogTemplate,
                companyData: this.companyData
            },
            after: {
                hide: (answer) => {
                    if (answer.removeParametrization) {
                        this.confirmRemoveParametrization();
                    } else if (answer.removeAccountsPlan) {
                        this.confirmRemoveAccountsPlan();
                    }
                },
                cancel: () => {}
            }
        });
    }

    confirmRemoveParametrization() {
        this.DesnuDialogService.confirmation({
            locals: {
                title: "Tem certeza que deseja excluir?",
                description: `
                    Essa ação é <span class="font-weight-semi-bold">irreversível</span> e vai <span class="font-weight-semi-bold">excluir toda a parametrização</span> da empresa ${this.company.props.name}.
                    <br>
                    <br>
                    Caso esta parametrização tenha sido copiada, as demais empresas <span class="font-weight-semi-bold">não serão afetadas</span>.
                `,
                destructive: true,
                confirmBefore: {
                    label:
                        "Compreendo que estou excluindo toda a parametrização.",
                    value: false
                },
                actions: {
                    confirm: {
                        label: "Excluir Parametrização",
                        confirmBefore: true,
                        action: () => {
                            this.$mdDialog.hide();
                            this.removeParametrization();
                        }
                    },
                    escape: {
                        label: "Voltar",
                        action: () => {
                            this.$mdDialog.cancel();
                        }
                    }
                }
            },
            after: {
                hide: (answer) => {},
                cancel: () => {}
            }
        });
    }

    async removeParametrization() {
        this.loading = true;
        this.LoaderService.setProgress(true);
        const response = await this.Serie.removeAccountsPlan({
            companyId: this.company.props._id,
            option: {
                cleanParametrization: true
            }
        });
        if (response.success) {
            const seriesToUnparameterize = [];
            for (const serieId of Object.keys(
                this.seriesNucontWithAssociated
            )) {
                seriesToUnparameterize.push({
                    _id: serieId,
                    associated: []
                });
            }
            this.Serie._associateUpdateCollection(seriesToUnparameterize);
            this.handleAfterRemoveAccountsPlan({
                removeParametrization: true,
                removeAccountsPlan: false
            });
        }
        this.loading = false;
        this.LoaderService.setProgress(false);
    }

    confirmRemoveAccountsPlan() {
        this.DesnuDialogService.confirmation({
            locals: {
                title: "Tem certeza que deseja excluir?",
                description: `
                    Essa ação é <span class="font-weight-semi-bold">irreversível</span> e vai <span class="font-weight-semi-bold">excluir o plano de contas e parametrização</span> da empresa ${this.company.props.name}.
                    <br>
                    <br>
                    Caso esta parametrização tenha sido copiada, as demais empresas <span class="font-weight-semi-bold">não serão afetadas</span>.
                `,
                destructive: true,
                confirmBefore: {
                    label:
                        "Compreendo que estou excluindo o plano de contas e parametrização.",
                    value: false
                },
                actions: {
                    confirm: {
                        label: "Excluir plano de contas e parametrização",
                        confirmBefore: true,
                        action: () => {
                            this.$mdDialog.hide();
                            this.removeAccountsPlan();
                        }
                    },
                    escape: {
                        label: "Voltar",
                        action: () => {
                            this.$mdDialog.cancel();
                        }
                    }
                }
            },
            after: {
                hide: (answer) => {},
                cancel: () => {}
            }
        });
    }

    async removeAccountsPlan() {
        this.loading = true;
        this.LoaderService.setProgress(true);
        const response = await this.Serie.removeAccountsPlan({
            companyId: this.company.props._id
        });
        if (response.success) {
            this.Serie.deleteMany({
                companyId: { $eq: "EMPRESA_NUCONT" }
            });
            this.Serie.deleteMany({
                companyId: { $eq: this.company.props._id },
                sources: { $in: ["accounting"] }
            });
            this.Available.deleteMany({
                companyId: this.company.props._id
            });
            this.handleAfterRemoveAccountsPlan({
                removeParametrization: false,
                removeAccountsPlan: true
            });
        }
        this.loading = false;
        this.LoaderService.setProgress(false);
    }

    async resetAutoAssociated() {
        await this.Company.updateFields(
            this.accountingId,
            this.company.props._id,
            {
                unsetAutoAssociated: true
            }
        );
    }

    onOpenHelpDialog() {
        this.DesnuDialogService.custom({
            controller: "HelpParameterizationDialogCtrl as $ctrl",
            clickOutsideToClose: true,
            locals: {
                templateHtml: helpParameterizationDialogTemplate,
                width: "437px",
                title: this.serieNucontSelected.name,
                serie: this.serieNucontSelected
            },
            after: {
                hide: () => {},
                cancel: () => {}
            }
        });
    }

    onCloseParameterization() {
        if (this.hasChangeSeries) {
            this.DesnuDialogService.confirmation({
                locals: {
                    title: "Tem certeza que deseja sair sem salvar?",
                    description: `Se sair agora, a <span class="font-weight-semi-bold">parametrização realizada será perdida</span>.
                        <br>
                        <br>
                        Gostaria de salvá-la?`,
                    actions: {
                        escape: {
                            label: "Não Salvar",
                            action: () => {
                                this.$mdDialog.cancel();
                                this.handleCloseParameterization();
                            }
                        },
                        confirm: {
                            label: "Salvar",
                            action: () => {
                                this.$mdDialog.hide();
                                this.onSave();
                            }
                        },
                        cancel: {
                            label: "Cancelar",
                            action: () => {
                                this.$mdDialog.cancel();
                            }
                        }
                    }
                },
                after: {
                    hide: (answer) => {},
                    cancel: () => {}
                }
            });
        } else {
            this.handleCloseParameterization();
        }
    }

    onSearchSerieNucont() {
        this.filterAccountsPlanNucont();
    }

    filterAccountsPlanNucont() {
        if (!this.searchSerieNucont || this.searchSerieNucont.trim() === "") {
            this.accountsPlanNucontFiltered = this.accountsPlanNucont;
            return;
        }
        const searchTerm = NormalizeString.normalizeUpperCaseNd(
            this.searchSerieNucont
        );
        this.accountsPlanNucontFiltered = this.accountsPlanNucont.filter(
            (serie) => {
                const serieName = NormalizeString.normalizeUpperCaseNd(
                    serie.name
                );
                const matchName = serieName.includes(searchTerm);
                const clasifierView = NormalizeString.normalizeUpperCaseNd(
                    serie.classifierView
                );
                const matchClassifierView = clasifierView.includes(searchTerm);
                return matchName || matchClassifierView;
            }
        );
    }

    onSearchSerieCompany() {
        this.filterAccountsPlanCompany();
    }

    filterAccountsPlanCompany() {
        if (!this.searchSerieCompany || this.searchSerieCompany.trim() === "") {
            this.accountsPlanCompanyFiltered = this.accountsPlanCompany;
        }
        const searchTerm = NormalizeString.normalizeUpperCaseNd(
            this.searchSerieCompany
        );
        this.accountsPlanCompanyFiltered = this.accountsPlanCompany.filter(
            (serie) => {
                const serieName = NormalizeString.normalizeUpperCaseNd(
                    serie.name
                );
                const matchName = serieName.includes(searchTerm);
                const clasifier = NormalizeString.normalizeUpperCaseNd(
                    String(serie.classifier)
                );
                const matchClassifier = clasifier.includes(searchTerm);
                const matchCode = String(serie.code).includes(searchTerm);
                return matchName || matchClassifier || matchCode;
            }
        );
    }

    setVisualizationsList() {
        if (!this.visualizations?.length) return;
        const items = this.visualizations.map((visualization) => ({
            label: visualization.name,
            value: visualization._id,
            checked: this.visualizationSelected?._id === visualization._id
        }));
        this.visualizationsList = [
            {
                label: this.dashboard.name,
                value: this.dashboard._id,
                items: [
                    {
                        label: "Selecionar Todos",
                        value: "select-all",
                        checked: false
                    },
                    ...items
                ]
            }
        ];
        this.visualizationsListBefore = angular.copy(this.visualizationsList);
    }

    onApplyVisualizations() {
        this.visualizationsListBefore = angular.copy(this.visualizationsList);
        const series = this.getSeries();
        this.seriesIdsToParameterize = series.map((serie) => serie._id);
        this.setAccountsPlanNucont();
        this.serieNucontSelected = this.accountsPlanNucont.find(
            (serie) => serie._id === this.seriesIdsToParameterize[0]
        );
        this.setAccountsPlanCompany();
        this.setSeriesParentsMap();
        this.setCompanySeriesPlanDisabled();
        this.filterAccountsPlanNucont();
        this.filterAccountsPlanCompany();
    }

    getSeries() {
        const visualizationsIds = this.visualizationsList.flatMap((item) =>
            item.items
                .map((item) => (item.checked ? item.value : null))
                .filter(Boolean)
        );
        const visualizations = this.visualizations.filter((visualization) =>
            visualizationsIds.includes(visualization._id)
        );
        const seriesIds = visualizations.flatMap((visualization) => [
            ...visualization.series,
            visualization.highlightsSeriesIds
        ]);
        const series = this.SeriesService.getByByIds(seriesIds);
        const dependenciesIds = this.getDependecies(series);
        const dependencies = this.SeriesService.getByByIds(dependenciesIds);
        return dependencies;
    }

    getDependecies(series) {
        let dependencies = [];
        for (const serie of series) {
            if (serie.dependency) {
                dependencies = dependencies.concat(serie.dependency);
            }
        }
        dependencies = _.uniq(dependencies);
        return dependencies;
    }

    afterHidePopover() {
        this.visualizationsList = angular.copy(this.visualizationsListBefore);
    }

    getVisualizationsSelected() {
        const visualizationsIds = this.visualizationsListBefore.flatMap(
            (item) =>
                item.items
                    .map((item) => (item.checked ? item.value : null))
                    .filter(Boolean)
        );
        const selectedVisualizations = this.visualizations
            .filter((visualization) =>
                visualizationsIds.includes(visualization._id)
            )
            .map((visualization) => visualization.name);
        if (selectedVisualizations?.length > 1) {
            return `${selectedVisualizations?.[0]} +${
                selectedVisualizations?.length - 1
            }`;
        }
        return selectedVisualizations?.[0];
    }

    onCheckVisualization(item) {
        setTimeout(() => {
            if (item.value === "select-all") {
                this.visualizationsList.forEach((visualization) => {
                    visualization.items.forEach((child) => {
                        if (item.checked) {
                            child.checked = true;
                        } else {
                            child.checked = false;
                        }
                    });
                });
            }
            this.$scope.$applyAsync();
        }, 100);
    }

    hasVisualizationsSelected() {
        return this.visualizationsList?.some((item) =>
            item?.items?.some((item) => item?.checked)
        );
    }

    scrollToActiveSerieNucont() {
        this.$timeout(() => {
            if (!this.serieNucontSelected?._id) return;

            const listElement = this.$element[0].querySelector(
                ".accounts-plan-nucont-list"
            );
            const activeElement = this.$element[0].querySelector(
                ".accounts-plan-nucont-list li.active"
            );

            if (listElement && activeElement) {
                const listRect = listElement.getBoundingClientRect();
                const activeRect = activeElement.getBoundingClientRect();
                const scrollTop =
                    activeElement.offsetTop -
                    listElement.offsetTop -
                    listRect.height / 2 +
                    activeRect.height / 2;

                listElement.scrollTo({
                    top: scrollTop,
                    behavior: "smooth"
                });
            }
        }, 100);
    }

    getTooltipDisabled(serie) {
        if (!this.serieNucontSelected?._id)
            return "Escolha uma conta no Plano Nucont à esquerda para parametrizar.";
        if (this.isSerieDisabledToParameterize(serie)) {
            const parents = this.seriesParentsMap[serie._id] || {};
            const childrens = parents.childrens || [];
            const fathers = parents.fathers || [];
            const hasChildrensParameterized = childrens.some((child) => {
                const childSerie = this.accountsPlanCompany.find(
                    (s) => s._id === child
                );
                if (!childSerie) return false;
                return this.isParameterized(childSerie);
            });
            const hasFathersParameterized = fathers.some((father) => {
                const fatherSerie = this.accountsPlanCompany.find(
                    (s) => s._id === father
                );
                if (!fatherSerie) return false;
                return this.isParameterized(fatherSerie);
            });
            if (hasChildrensParameterized) {
                return "As contas análiticas já foram parametrizadas.";
            } else if (hasFathersParameterized) {
                return "A conta sintética já foi parametrizada.";
            }
        }
        return "";
    }
}

export { ParameterizationAccountsPlanComponent };

ParameterizationAccountsPlanComponent.$inject = [
    "DesnuDialogService",
    "$scope",
    "$mdDialog",
    "$timeout",
    "$element",
    "LoaderService",
    "ChatHubsbotService"
];

const name = "parameterizationAccountsPlanComponent";
const def = {
    bindings: {
        companyData: "<",
        accountingId: "<",
        seriesIdsToParameterize: "<",
        serieNucontSelected: "<",
        visualizations: "<",
        visualizationSelected: "<",
        dashboard: "<",
        configs: "<",
        handleAfterRemoveAccountsPlan: "&",
        handleAfterSave: "&",
        handleCloseParameterization: "&"
    },
    controller: ParameterizationAccountsPlanComponent,
    template
};
angular.module("nucont.shared").component(name, def);
export default { name, ...def };
